import React from 'react'
import { Controller } from 'react-hook-form'
import ReCAPTCHA from 'react-google-recaptcha'
import type { Control } from 'react-hook-form'

interface CaptchaFieldProps {
  name: string
  control: Control<any>
  className?: string
}

const CaptchaField = ({ name, control, className }: CaptchaFieldProps) => {
  const siteKey = (import.meta.env.VITE_RECAPTCHA_SITE_KEY as string) ?? ''

  // If no site key provided, don't render captcha (useful for local/dev when not configured)
  if (!siteKey) return null

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={undefined}
      render={({ field }) => (
        <div className={className}>
          <ReCAPTCHA
            sitekey={siteKey}
            onChange={(token) => field.onChange(token ?? undefined)}
            onExpired={() => field.onChange(undefined)}
          />
        </div>
      )}
    />
  )
}

export default CaptchaField

